export const CommentEditFocusEvent: string = 'comment.editFocus';
export const CommentReplyFocusEvent: string = 'comment.replyFocus';

export const MaintenanceUpdatedEvent: string = 'maintenanceUpdated';

export const OptionCreatedEvent: string = 'optionCreated';
export const OptionDeletedEvent: string = 'optionDeleted';
export const OptionUpdatedEvent: string = 'optionUpdated';
export const TopicCreatedEvent: string = 'topicCreated';
export const TopicUpdatedEvent: string = 'topicUpdated';
export const TopicDeletedEvent: string = 'topicDeleted';
export const VersionUpdatedEvent: string = 'versionUpdated';
export const FileUpdatedEvent: string = 'fileUpdated';
export const FileDeletedEvent: string = 'fileDeleted';
export const KpfFileDeletedEvent: string = 'kpfFileDeleted';
export const FileMovedEvent: string = 'fileMoved';
export const FilesDeletedEvent: string = 'filesDeleted';
export const FileScannedTranscodedEvent: string = 'fileScannedTranscoded';
export const FileTranscodedEvent: string = 'fileTranscoded';
export const KpfFolderCreatedEvent: string = 'kpfFolderCreated';
export const ReleaseFileMovedEvent: string = 'releaseFileMoved';
export const KpfFolderDeletedEvent: string = 'kpfFolderDeleted';

export const AuthUserUpdatedEvent: string = 'authUserUpdated';
export const AuthTokenUpdatedEvent: string = 'authTokenUpdated';
export const AllowedOperationsUpdatedEvent: string = 'authUser.update';
export const ProfileSettingsUpdatedEvent: string = 'profileSettingsUpdated';
export const UserLoggedOutEvent: string = 'userLoggedOut';

export const AssignPriority: string = 'assignPriority';
export const BlobPicture: string = 'blobPicture';
export const BrandId: string = 'brandId';
export const ErrorValue: string = 'Error';
export const FirstName: string = 'firstName';
export const FullName: string = 'fullName';
export const LastName: string = 'lastName';
export const LeftBarReporting: string = 'leftBarReporting';
export const MenuSubtitle: string = 'menuSubtitle';
export const NewCampaign: string = 'newCampaign';
export const ProjectArchive: string = 'project_archive';
export const ProjectConfirmArchive: string = 'project_confirmArchive';
export const ProjectDeleteConfirm: string = 'projectDeleteConfirm';
export const ProjectDeleteTitle: string = 'projectDeleteTitle';
export const WorkspaceComponent: string = 'workspaceComponent';
export const WorkspaceName: string = 'workspaceName';
export const WorkspaceV2Id: string = 'workspaceV2Id';
export const SelectWorkspaceLabel: string = 'Select Workspace';
export const SelectPriorityLabel: string = 'Select Priority';
export const SelectStatusLabel: string = 'Select Status';

export const BrandUpdatedEvent: string = 'BRAND_UPDATED';
export const DriveCampaignEvent: string = 'DRIVE_CAMPAIGN';
export const CalendarFilterUpdatedEvent: string = 'CALENDAR_FILTER_UPDATED';
export const CampaignProjectDeletedEvent: string = 'CAMPAIGN_PROJECT_DELETED';
export const CampaignProjectStatusUpdatedEvent: string = 'CAMPAIGN_PROJECT_STATUS_UPDATED';
export const CampaignDataUpdatedEvent: string = 'CAMPAIGN_DATA_UPDATED';
export const ProjectAssetLinkedEvent: string = 'PROJECT_ASSET_LINKED';
export const NewAssetAddedEvent: string = 'NEW_ASSET_ADDED';

export const DriveCampaignFormUpdatedEvent: string = 'DRIVE_CAMPAIGN:FORM_UPDATED';
export const DriveCampaignActivePageEvent: string = 'DRIVE_CAMPAIGN:ACTIVE_PAGE';

export const CloseAllDropdownsEvent: string = 'CLOSE_ALL_DROPDOWNS';
